const INTERNAL_LINKS = {
  LOGIN: '/login',
  HOME: '/',
  SURVEY_HOME: '/survey-home',
  GLOBAL_REGIONAL_SURVEY_HOME: '/global-regional-survey-home',
  POLL_HOME: '/poll-home',
  POLL_CHAPTER_I: '/poll-chapter-i',
  POLL_CHAPTER_II: '/poll-chapter-ii',
  POLL_CHAPTER_III: '/poll-chapter-iii',
  POLL_CHAPTER_IV: '/poll-chapter-iv',
  POLL_POLICIES: '/poll-policies',
  POLL_CHAPTER_V: '/poll-chapter-v',
  GLOBAL_REGIONAL_POLL_HOME: '/global-regional-poll-home',
  GLOBAL_REGIONAL_POLL_CHAPTER_I: '/global-regional-poll-chapter-i',
  GLOBAL_REGIONAL_POLL_CHAPTER_III: '/global-regional-poll-chapter-iii',
  GLOBAL_REGIONAL_POLL_CHAPTER_V: '/global-regional-poll-chapter-v',
  REPORTS: '/reports',
  FILES: '/files',
  FILE: '/file',
};

export default INTERNAL_LINKS;